import { CandidateRow } from '@shared/models/element-import.model';
import { searchFilter } from '@shared/helpers/string.helpers';
import {
  CANDIDATE_STATUS_LABEL,
  CandidateRowStatus,
} from './candidate-status.helpers';

type CandidateSearchContext = {
  /** Mapped product display name, when the row resolves to a product. */
  productName: string | undefined;
  status: CandidateRowStatus;
};

const buildSearchHaystack = (
  row: CandidateRow,
  { productName, status }: CandidateSearchContext,
): string => {
  const rawValues = Object.values(row.raw).map((v) => String(v ?? ''));
  return [
    ...rawValues,
    row.resourceCode ?? '',
    productName ?? '',
    CANDIDATE_STATUS_LABEL[status],
  ].join(' ');
};

/**
 * Match a candidate row against the shared element-list search query (URL
 * `?search=`). Mirrors the products tab semantics: empty query passes; a
 * non-empty query is split into space-separated parts that must *all* appear
 * (case-insensitive) somewhere in the haystack.
 *
 * Haystack covers raw CSV cell values, the resource code, the mapped product
 * name (if any) and the status label, so users can filter by free text, code,
 * mapped product or status keyword (e.g. "incomplete").
 */
export const matchesCandidateSearch = (
  row: CandidateRow,
  search: string,
  context: CandidateSearchContext,
): boolean => {
  if (!search.trim()) return true;
  return searchFilter(buildSearchHaystack(row, context), search);
};
